module.exports = __webpack_public_path__ + "static/media/book_a129.ee7f09e3.jpg";